import React from 'react';
import Link from '@v2/shared/components/Link';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';

/**
 * The three site links MagZoom's header carries beside the account ones, and MagSpot's
 * does not — `About Us | FAQ | Contact Us`, from the `info-links` block of
 * `layouts/full/header.html`.
 *
 * The legacy header hides them below `xs` with `hidden-xs`; here they are absent from
 * the header on a phone and appear in the panel the hamburger opens, alongside the
 * account links, which is where the drawer put them.
 */
export default function InfoLinks() {
  const { buildUrl } = useUrlGenerator();

  const className = 'text-sm text-slate-700 no-underline hover:text-primary';

  return (
    <span className="whitespace-nowrap">
      <Link href={buildUrl('/about-us')} className={className}>
        About Us
      </Link>
      <span className="px-1.5 text-slate-400">|</span>
      <Link href={buildUrl('/help')} className={className}>
        FAQ
      </Link>
      <span className="px-1.5 text-slate-400">|</span>
      <Link href={buildUrl('/contact')} className={className}>
        Contact Us
      </Link>
    </span>
  );
}
